<div class="content-body">
  <app-breadcrumb [breadcrumb]="breadcrumbList"></app-breadcrumb>
  <div class="container-fluid">
    <div class="card">
      <div class="card-header d-flex justify-content-between align-items-center">
        <h4 class="card-title">Leads List</h4>
        <button *ngIf="canAdd" class="btn btn-primary btn-sm" (click)="openLeadModal()"
          [disabled]="loadingService.isLoading()">
          <i class="bi bi-plus-circle me-1"></i> Create Lead
        </button>
      </div>
      <div class="card-body">
        <!-- Filters -->
        <form [formGroup]="searchForm">
          <div class="row mb-3">
            <div class="col-md-4">
              <label class="form-label">Search</label>
              <input type="text" class="form-control input-default search-textbox-height" formControlName="search"
                placeholder="Search by name, phone, email..." />
            </div>
            <div class="col-md-3">
              <label class="form-label">Source</label>
              <select class="form-select input-default search-textbox-height" formControlName="source"
                (change)="handleSearch('')">
                <option value="">All Sources</option>
                <option *ngFor="let option of sourceOptions" [value]="option.value">
                  {{ option.label }}
                </option>
              </select>
            </div>
            <div class="col-md-2">
              <label class="form-label">Stage</label>
              <select class="form-select input-default search-textbox-height" formControlName="stage"
                (change)="handleSearch('')">
                <option value="">All Stages</option>
                <option *ngFor="let option of stageOptions" [value]="option.value">
                  {{ option.label }}
                </option>
              </select>
            </div>
            <div class="col-md-2">
              <label class="form-label">Status</label>
              <select class="form-select input-default search-textbox-height" formControlName="status"
                (change)="handleSearch('')">
                <option value="">All Statuses</option>
                <option *ngFor="let option of statusOptions" [value]="option.value">
                  {{ option.label }}
                </option>
              </select>
            </div>
            <div class="col-md-3">
              <label class="form-label">Assigned To</label>
              <ng-select ngDefaultControl [items]="assignedToUsers" bindValue="value" bindLabel="label"
                placeholder="Select User" class="select2 select2-sm" formControlName="assigned_to"
                [typeahead]="searchUsers$" [virtualScroll]="true" (scrollToEnd)="onUserScrollEnd()"
                (change)="handleSearch('')">
                <ng-template #template let-data="data">{{ data.label }}</ng-template>
              </ng-select>
            </div>
            <div class="col-md-2 d-flex align-items-end">
              <button type="button" class="btn btn-secondary btn-sm" (click)="resetSearchForm()"
                [disabled]="!disableClear || loadingService.isLoading()">
                Clear Filters
              </button>
            </div>
          </div>
        </form>

        <!-- Table -->
        <div class="table-responsive">
          <table class="table table-hover" matSort (matSortChange)="sortData($event)">
            <thead>
              <tr>
                <th mat-sort-header="created_at">Created At</th>
                <th mat-sort-header="name">Name</th>
                <th mat-sort-header="source">Source</th>
                <th mat-sort-header="follow_up_date">Follow Up On</th>
                <th mat-sort-header="stage">Stage</th>
                <th mat-sort-header="status">Status</th>
                <th class="notes-col-header">Notes</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngIf="loadingService.isLoading()">
                <td colspan="8" class="text-center py-4">
                  <div class="spinner-border text-primary" role="status">
                    <span class="visually-hidden">Loading...</span>
                  </div>
                </td>
              </tr>
              <tr *ngIf="!loadingService.isLoading() && leads.length === 0">
                <td colspan="8" class="text-center py-4">No leads found</td>
              </tr>
              <tr *ngFor="let lead of leads" [ngClass]="{'follow-up-highlight': isFollowUpSoon(lead.follow_up_date)}">
                <td>{{ lead.created_at | date: 'dd-MM-yyyy' }}</td>
                <td>
                  <span class="lead-name-link" (click)="viewLead(lead.id)">{{ lead.name }}</span>
                </td>
                <td>
                  <span *ngIf="lead.source" class="badge" [ngClass]="sourceClass(lead)"
                    [title]="lead.source_website || lead.source">{{ lead.source }}</span>
                  <small *ngIf="lead.source_website" class="d-block fw-semibold" [ngClass]="websiteClass(lead.source_website)">
                    {{ lead.source_website }}
                  </small>
                  <span *ngIf="!lead.source">-</span>
                </td>
                <td>{{ lead.follow_up_date ? (lead.follow_up_date | date: 'dd-MM-yyyy') : '-' }}</td>
                <td>
                  <span class="badge" [ngClass]="{
                      'bg-secondary': lead.stage == 'New',
                      'bg-info': lead.stage == 'Reached Out' || lead.stage == 'Introduction Done',
                      'bg-primary': lead.stage == 'Inspection Done',
                      'bg-warning text-dark': lead.stage == 'Draft Agreement Sent' || lead.stage == 'Final Agreement Sent',
                      'bg-success': lead.stage == 'Token/Fee Paid'
                    }">
                    {{ lead.stage }}
                  </span>
                </td>
                <td>
                  <span class="badge" [ngClass]="{
                      'bg-danger': lead.status == 'Hot',
                      'bg-warning text-dark': lead.status == 'Warm',
                      'bg-info': lead.status == 'Cold',
                      'bg-secondary': lead.status == 'Reject',
                      'bg-success': lead.status == 'Converted'
                    }">
                    {{ lead.status }}
                  </span>
                </td>
                <td class="notes-cell">
                  <div class="notes-content">{{ lead.looking_for || '-' }}</div>
                </td>
                <td>
                  <div class="d-flex">
                    <button *ngIf="canUpdate" class="btn btn-info shadow btn-xs sharp me-1"
                      (click)="openLeadModal(lead.id)" title="Edit Lead">
                      <i class="fa fa-pencil"></i>
                    </button>
                    <button *ngIf="canDelete" class="btn btn-danger shadow btn-xs sharp me-1"
                      (click)="deleteLead(lead.id)" title="Delete Lead">
                      <i class="fa fa-trash"></i>
                    </button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Pagination -->
        <div class="d-flex justify-content-between align-items-center mt-3">
          <div class="dataTables_info">
            Showing {{ (page - 1) * limit + 1 }} to {{ (page - 1) * limit + totalRows }} of {{ totalLeads }} entries
          </div>
          <app-pagination [page]="page" [totalPage]="totalPage" (newPage)="pageChange($event)"></app-pagination>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Lead Create/Edit Modal -->
<div #leadModal class="offcanvas offcanvas-end customeoff {{ showLeadModal ? 'show':''}}" tabindex="-1" id="leadModal"
  data-bs-backdrop="static">

  <!-- Header -->
  <div class="offcanvas-header">
    <h5 class="modal-title">{{ isEditMode ? 'Edit Lead' : 'Create Lead' }}</h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="closeLeadModal()">
      <i class="fa-solid fa-xmark"></i>
    </button>
  </div>

  <!-- Body Content -->
  <div class="offcanvas-body">
    <div class="container-fluid">
      <form [formGroup]="leadForm" (ngSubmit)="onSubmit()" autocomplete="off">
        <div class="row">
          <!-- Service -->
          <div class="col-xl-6 mb-3">
            <label class="form-label">Service</label>
            <select class="form-select" formControlName="service">
              <option value="">Select Service</option>
              <option *ngFor="let option of serviceOptions" [value]="option.value">
                {{ option.label }}
              </option>
            </select>
          </div>

          <!-- Stage (Only for Edit Mode) -->
          <div class="col-xl-6 mb-3" *ngIf="isEditMode">
            <label class="form-label">Stage</label>
            <select class="form-select" formControlName="stage">
              <option value="">Select Stage</option>
              <option *ngFor="let option of stageOptions" [value]="option.value">
                {{ option.label }}
              </option>
            </select>
          </div>

          <!-- Status (Only for Edit Mode) -->
          <div class="col-xl-6 mb-3" *ngIf="isEditMode">
            <label class="form-label">Status</label>
            <select class="form-select" formControlName="status">
              <option value="">Select Status</option>
              <option *ngFor="let option of statusOptions" [value]="option.value">
                {{ option.label }}
              </option>
            </select>
          </div>

          <!-- Source -->
          <div class="col-xl-6 mb-3">
            <label class="form-label">Source <span class="text-danger">*</span></label>
            <select class="form-select" formControlName="source" [class.is-invalid]="isFieldInvalid('source')">
              <option value="">Select Source</option>
              <option *ngFor="let option of sourceOptions" [value]="option.value">
                {{ option.label }}
              </option>
            </select>
            <div class="invalid-feedback" *ngIf="isFieldInvalid('source')">
              Source is required
            </div>
          </div>

          <!-- Property Type -->
          <div class="col-xl-6 mb-3">
            <label class="form-label">Property Type</label>
            <input type="text" class="form-control" formControlName="property_type" placeholder="Enter property type" />
          </div>

          <!-- Name -->
          <div class="col-xl-6 mb-3">
            <label class="form-label">Name <span class="text-danger">*</span></label>
            <input type="text" class="form-control" formControlName="name" placeholder="Enter name"
              [class.is-invalid]="isFieldInvalid('name')" />
            <div class="invalid-feedback" *ngIf="isFieldInvalid('name')">
              Name is required
            </div>
          </div>

          <!-- Email -->
          <div class="col-xl-6 mb-3">
            <label class="form-label">Email</label>
            <input type="email" class="form-control" formControlName="email" placeholder="Enter email"
              [class.is-invalid]="isFieldInvalid('email')" />
            <div class="invalid-feedback" *ngIf="isFieldInvalid('email')">
              Invalid email format
            </div>
          </div>

          <!-- Phone -->
          <div class="col-xl-6 mb-3">
            <label class="form-label">Phone</label>
            <input type="tel" class="form-control" formControlName="phone" placeholder="Enter phone number" />
          </div>

          <!-- Locality -->
          <div class="col-xl-6 mb-3">
            <label class="form-label">Locality</label>
            <input type="text" class="form-control" formControlName="locality" placeholder="Enter locality" />
          </div>

          <!-- City -->
          <div class="col-xl-6 mb-3">
            <label class="form-label">City</label>
            <input type="text" class="form-control" formControlName="city" placeholder="Enter city" />
          </div>

          <!-- State -->
          <!-- <div class="col-xl-6 mb-3">
            <label class="form-label">State</label>
            <input type="text" class="form-control" formControlName="state" placeholder="Enter state" />
          </div> -->

          <!-- Follow Up On -->
          <div class="col-xl-6 mb-3">
            <label class="form-label">Follow Up On</label>
            <input type="date" class="form-control" formControlName="follow_up_date" />
          </div>

          <!-- Customer Location -->
          <div class="col-xl-6 mb-3">
            <label class="form-label">Customer Location</label>
            <input type="text" class="form-control" formControlName="customer_location"
              placeholder="Enter customer location" />
          </div>

          <!-- Customer City -->
          <!-- <div class="col-xl-6 mb-3">
            <label class="form-label">Customer City</label>
            <input type="text" class="form-control" formControlName="customer_city" placeholder="Enter customer city" />
          </div> -->

          <!-- Customer State -->
          <!-- <div class="col-xl-6 mb-3">
            <label class="form-label">Customer State</label>
            <input type="text" class="form-control" formControlName="customer_state"
              placeholder="Enter customer state" />
          </div> -->

          <!-- Looking For -->
          <div class="col-12 mb-3">
            <label class="form-label">Quick Notes</label>
            <textarea class="form-control" formControlName="looking_for" rows="8"
              placeholder="Enter what the customer is looking for"></textarea>
          </div>

          <!-- Assigned To -->
          <div class="col-xl-6 mb-3">
            <label class="form-label">Assigned To</label>
            <ng-select ngDefaultControl [items]="assignedToUsers" bindValue="value" bindLabel="label"
              placeholder="Select User" class="select2" formControlName="assigned_to" [typeahead]="searchUsers$"
              [virtualScroll]="true" (scrollToEnd)="onUserScrollEnd()">
              <ng-template #template let-data="data">{{ data.label }}</ng-template>
            </ng-select>
          </div>

          <!-- Google Maps Link -->
          <div class="col-xl-6 mb-3">
            <label class="form-label">Google Maps Link</label>
            <input type="text" class="form-control" formControlName="maps_link" placeholder="Google Maps URL" />
          </div>

          <!-- Existing attachments (edit mode) -->
          <div class="col-xl-12 mb-3" *ngIf="isEditMode && existingUploads.length > 0">
            <label class="form-label">Uploaded Attachments</label>
            <ul class="list-group">
              <li class="list-group-item d-flex justify-content-between align-items-center"
                *ngFor="let file of existingUploads">
                <a [href]="file.upload_key" target="_blank" rel="noopener" class="text-truncate">
                  {{ file.original_name || 'Attachment' }}
                </a>
                <button type="button" class="btn btn-sm btn-outline-danger"
                  (click)="deleteExistingUpload(file.id)">Delete</button>
              </li>
            </ul>
          </div>

          <!-- Attachments -->
          <div class="col-xl-12 mb-3">
            <label class="form-label">{{ isEditMode ? 'Add Attachments' : 'Attachments' }}</label>
            <input type="file" class="form-control" [accept]="acceptAttr" multiple
              (change)="onFilesSelected($event)" />
            <small class="text-muted">
              Images, PDF, DOCX, CSV, Excel. Up to {{ maxFileSizeMb }}MB per file. Multiple files allowed.
            </small>
            <ul class="list-group mt-2" *ngIf="selectedFiles.length > 0">
              <li class="list-group-item d-flex justify-content-between align-items-center"
                *ngFor="let file of selectedFiles; let i = index">
                <span class="text-truncate">{{ file.name }}</span>
                <button type="button" class="btn btn-sm btn-outline-danger" (click)="removeFile(i)">Remove</button>
              </li>
            </ul>
          </div>
        </div>

        <!-- Form Actions -->
        <div>
          <button class="btn btn-primary ms-1 me-3" type="submit"
            [disabled]="leadForm.invalid || loadingService.isLoading()">
            {{ isEditMode ? 'Update Lead' : 'Create Lead' }}
          </button>
          <button class="btn btn-danger light me-1" type="button" (click)="closeLeadModal()">
            Cancel
          </button>
        </div>
      </form>
    </div>
  </div>
</div>

<!-- Backdrop -->
@if(showLeadModal){
<div class="offcanvas-backdrop fade show" (click)="closeLeadModal()"></div>
}
